import React from "react";

import type { T_PortfolioScrubDisplay } from "@lattice/shared-frontend/charts";

import { PortfolioAccountSelector } from "./PortfolioAccountSelector";
import { formatChange, formatCurrency, formatSignedPercent } from "./format";
import type { T_PortfolioHomeAccountOption } from "./types";
import "./portfolio-home.css";

export type T_PortfolioValueHeaderProps = {
  accountOptions: T_PortfolioHomeAccountOption[];
  isPositive: boolean;
  onAddManualHoldings: () => void;
  onConnectBrokerage: () => void;
  onSelectAccount: (accountId: string) => void;
  periodDollarChange: number;
  periodLabel: string;
  periodPercentChange: number;
  scrub: T_PortfolioScrubDisplay | null;
  selectedAccountId: string;
  totalValue: number;
};

export function PortfolioValueHeader({
  accountOptions,
  isPositive,
  onAddManualHoldings,
  onConnectBrokerage,
  onSelectAccount,
  periodDollarChange,
  periodLabel,
  periodPercentChange,
  scrub,
  selectedAccountId,
  totalValue,
}: T_PortfolioValueHeaderProps) {
  const positive = scrub ? scrub.isPositive : isPositive;
  return (
    <div className="portfolio-value-header">
      <div aria-live="polite" className="portfolio-value-header__values">
        <p
          className="portfolio-value-header__total"
          data-testid="portfolio-value-total"
        >
          {formatCurrency(scrub ? scrub.value : totalValue)}
        </p>
        <p className="portfolio-value-header__change">
          <span
            className={
              positive
                ? "portfolio-home__change portfolio-home__change--positive"
                : "portfolio-home__change portfolio-home__change--negative"
            }
          >
            {formatChange(scrub ? scrub.dollarChange : periodDollarChange)} (
            {formatSignedPercent(
              scrub ? scrub.percentChange : periodPercentChange,
            )}
            )
          </span>{" "}
          <span className="portfolio-value-header__period">
            {scrub ? scrub.label : periodLabel}
          </span>
        </p>
      </div>
      <PortfolioAccountSelector
        accounts={accountOptions}
        onAddManualHoldings={onAddManualHoldings}
        onConnectBrokerage={onConnectBrokerage}
        onSelect={onSelectAccount}
        selectedAccountId={selectedAccountId}
      />
    </div>
  );
}
